import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  useToast,
  Input,
  useDisclosure,
  Box,
  Select,
  Switch,
  Text,
  Icon,
  Checkbox,
  Spinner,
  Stack,
  FormHelperText,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AddIcon } from "@chakra-ui/icons";
import { CSVLink } from "react-csv";
import { Loader } from "../../Loader/loader";
import {
  onAddMerchant,
  getIndustries,
  getCustomization,
  getAreaMappingConfig,
  validateMerchantAreaMapping,
  updateMerchant,
  getMerchantPermissions,
  validateRecommendationFile,
  getUpdateRecommendationConfig,
  downloadRecommendationFileSample,
} from "../../../api/merchants";
import { convertToMerchant } from "api/leads";
import { AsyncSelect, Select as ReactSelect } from "chakra-react-select";
import { getCouriers } from "api/couriers";
import { getPricingPlansData } from "api/pricing-plans";
import { getSubStatus } from "api/orders";

const fetchPricingPlanOptions = async (query) => {
  query = query.trim();
  const { pricingPlans } = await getPricingPlansData({
    filters: { name: query.length > 0 ? query : undefined },
    limit: 5,
    page: 1,
  });
  return pricingPlans;
};

export function AddMerchant({ row, fetchData, filterQuery, isLead }) {
  const finalRef = React.useRef(null);
  const csvLink = React.useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { REACT_APP_ADMIN_API_URL: baseURL } = process.env;

  const UploadIcon = (props) => (
    <Icon width="24px" height="34px" viewBox="0 0 28 36" fill="none" {...props}>
      <path
        d="M23.1 14H25.7C26.0448 14 26.3754 14.1446 26.6192 14.402C26.863 14.6594 27 15.0085 27 15.3725V33.6275C27 33.9915 26.863 34.3406 26.6192 34.598C26.3754 34.8554 26.0448 35 25.7 35H2.3C1.95522 35 1.62456 34.8554 1.38076 34.598C1.13696 34.3406 1 33.9915 1 33.6275V15.3725C1 15.0085 1.13696 14.6594 1.38076 14.402C1.62456 14.1446 1.95522 14 2.3 14H4.9"
        stroke="#7F7D80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 25.6666V4.66663"
        stroke="#7F7D80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3335 9.33329L14.0002 4.66663L9.66683 9.33329"
        stroke="#7F7D80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );

  const SectionTitle = ({ children }) => (
    <Text
      fontSize={13}
      fontWeight={"bold"}
      color={"gray.600"}
      textTransform={"uppercase"}
      letterSpacing={"wide"}
      borderBottom={"1px solid"}
      borderColor={"gray.200"}
      pb={2}
    >
      {children}
    </Text>
  );

  const {
    register,
    handleSubmit,
    formState,
    setValue,
    watch,
    reset,
    unregister,
  } = useForm({
    defaultValues: {
      name: "",
      phone: "",
      hotline: "",
      email: "",
      prefix: "",
      industry: "",
      brand: "",
      password: "",
      order_creation_behavior: "",
      hide_pickup_location: false,
      permissions: [],
      allow_sms_notifications: false,
      sms_sender_name: "",
      integrator_fees_with_vat: 0,
      ramp_customer_code: "",
      ndr_enabled: false,
      ndr_report_email: "",
      ndr_report_email_cc: "",
      ndr_report_end_time: "",
      ndr_report_exclude_days: [],
      allowed_couriers: [],
      sms_allowed_couriers: [],
      general_notifications_enabled: false,
      general_notifications_allowed_couriers: [],
      general_notifications_allowed_triggers: [],
      order_confirmation_enabled: false,
      abandoned_checkouts: false,
      is_sub_brands_enabled: false,
      growth_module_enabled: false,
      shipping_module_enabled: true,
    },
  });

  const { errors, isDirty } = formState;
  const form = watch();
  const onError = (errors) => console.log(errors);
  const [merchantIndustries, setMerchantIndustries] = useState([]);
  const [customization, setCustomization] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [areaMappingConfig, setAreaMappingConfig] = useState({});
  const [areaMappingFile, setAreaMappingFile] = useState("");
  const [areaMappingErrorFile, setAreaMappingErrorFile] = useState("");
  const [courierRecommendationFile, setCourierRecommendationFile] = useState(
    ""
  );
  const [
    courierRecommendationFileError,
    setCourierRecommendationFileError,
  ] = useState("");
  const getToken = () => {
    return localStorage?.getItem("tokenKey");
  };
  const [couriersOptions, setCouriersOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const validateCourierRecommendationFile = async () => {
    const formData = new FormData();
    formData.append("file", courierRecommendationFile);
    const response = await validateRecommendationFile(formData, toast);
    if (response?.errors) throw new Error(response?.errors);
  };
  const validateAreaMappingFile = async () => {
    const formData = {
      file: areaMappingFile,
    };
    const response = await validateMerchantAreaMapping(
      formData,
      { "Content-Type": "multipart/form-data", Authorization: getToken() },
      toast
    );
    if (response?.errors) throw new Error(response?.errors);
  };
  const handelSubmit = async (data) => {
    if (isLead) {
      setOpenLoader(true);
      const files = {};

      if (form["order_creation_behavior"] === "custom" && areaMappingFile) {
        try {
          files["area-mapping"] = areaMappingFile;
          await validateAreaMappingFile();
        } catch (e) {
          setAreaMappingErrorFile(e.message);
          setOpenLoader(false);
          return;
        }
      }

      if (courierRecommendationFile && courierRecommendationFile !== "") {
        try {
          files["courier-recommendation"] = courierRecommendationFile;
          await validateCourierRecommendationFile();
        } catch (e) {
          setCourierRecommendationFileError(e.message);
          setOpenLoader(false);
          return;
        }
      }

      const body = {
        ...data,
        config: {
          ndr: {
            enabled: data.ndr_enabled,
            report_email: data.ndr_report_email || null,
            report_email_cc: data.ndr_report_email_cc || null,
            report_end_time: data.ndr_report_end_time || null,
            allowed_couriers: (data.allowed_couriers || []).map(
              (o) => o?.value ?? o
            ),
            report_exclude_days: data.ndr_report_exclude_days || [],
          },
          wa_general_notifications: {
            enabled: data.general_notifications_enabled || false,
            allowed_couriers: (data.general_notifications_allowed_couriers || []).map(
              (o) => o?.value ?? o
            ),
            allowed_triggers: (data.general_notifications_allowed_triggers || []).map(
              (o) => o?.value ?? o
            ),
          },
          order_confirmation: {
            enabled: data.order_confirmation_enabled || false,
          },
          abandoned_checkouts: {
            enabled: data.abandoned_checkouts || false,
          },
          is_sub_brands_enabled: data.is_sub_brands_enabled || false,
          modules: {
            growth: {
              enabled: data.growth_module_enabled || false,
            },
            shipping: {
              enabled: data.shipping_module_enabled ?? true,
            },
          },
        },
        sms_allowed_couriers: (data.sms_allowed_couriers || []).map(
          (o) => o?.value ?? o
        ),
        ...files,
        sms_allowed_couriers: (data?.sms_allowed_couriers || []).map(
          (o) => o?.value ?? o
        ),
      };
      try {
        await convertToMerchant(row._id, body, toast);
        onCloseModal();
      } catch (e) {
        console.error(e);
      } finally {
        setOpenLoader(false);
      }
    } else if (row) {
      setOpenLoader(true);
      const body = {
        hotline: data.hotline,
        hide_pickup_location: data.hide_pickup_location,
        permissions: data.permissions,
        allow_sms_notifications: data.allow_sms_notifications,
        sms_sender_name: data.allow_sms_notifications
          ? data.sms_sender_name || "Fincart EG"
          : null,
        sms_allowed_couriers: (data.sms_allowed_couriers || []).map(
          (o) => o?.value ?? o
        ),
        integratorFeeWithVAT: +data.integrator_fees_with_vat,
        brand: data.brand,
        ramp_customer_code: data.ramp_customer_code,
        config: {
          ndr: {
            enabled: data.ndr_enabled,
            report_email: data.ndr_report_email || null,
            report_email_cc: data.ndr_report_email_cc || null,
            report_end_time: data.ndr_report_end_time || null,
            allowed_couriers: (data.allowed_couriers || []).map(
              (o) => o?.value ?? o
            ),
            report_exclude_days: data.ndr_report_exclude_days || [],
          },
          wa_general_notifications: {
            enabled: data.general_notifications_enabled || false,
            allowed_couriers: (data.general_notifications_allowed_couriers || []).map(
              (o) => o?.value ?? o
            ),
            allowed_triggers: (data.general_notifications_allowed_triggers || []).map(
              (o) => o?.value ?? o
            ),
          },
          order_confirmation: {
            enabled: data.order_confirmation_enabled || false,
          },
          abandoned_checkouts: {
            enabled: data.abandoned_checkouts || false,
          },
          is_sub_brands_enabled: data.is_sub_brands_enabled || false,
          modules: {
            growth: {
              enabled: data.growth_module_enabled || false,
            },
            shipping: {
              enabled: data.shipping_module_enabled ?? true,
            },
          },
        },
      };
      const res = await updateMerchant(row._id, body, toast);
      if (res) {
        toast({
          status: "success",
          title: "",
          description: "Updated successfully",
        });
        setOpenLoader(false);
        onCloseModal();
      } else {
        setOpenLoader(false);
        onCloseModal();
      }
    } else {
      if (form["order_creation_behavior"] === "custom" && !areaMappingFile) {
        toast({
          status: "error",
          title: "Error",
          description: "Area mapping file is required",
        });
      } else {
        setOpenLoader(true);

        let fileErrors = "";
        if (form["order_creation_behavior"] === "custom" && areaMappingFile) {
          const formData = {
            file: areaMappingFile,
          };
          const response = await validateMerchantAreaMapping(
            formData,
            {
              "Content-Type": "multipart/form-data",
              Authorization: getToken(),
            },
            toast
          );
          fileErrors = response?.errors;

          if (fileErrors) {
            setAreaMappingErrorFile(fileErrors);
          }
        }

        if (!fileErrors) {
          const body = {
            ...data,
            ...(form["order_creation_behavior"] === "custom"
              ? { file: areaMappingFile }
              : {}),
            sms_allowed_couriers: (data?.sms_allowed_couriers || []).map(
              (o) => o?.value ?? o
            ),
            sms_sender_name: data.allow_sms_notifications
              ? data.sms_sender_name || "Fincart EG"
              : null,
            config: {
              ndr: {
                enabled: data.ndr_enabled,
                report_email: data.ndr_report_email || null,
                report_email_cc: data.ndr_report_email_cc || null,
                report_end_time: data.ndr_report_end_time || null,
                allowed_couriers: (data.allowed_couriers || []).map(
                  (o) => o?.value ?? o
                ),
                report_exclude_days: data.ndr_report_exclude_days || [],
              },
              wa_general_notifications: {
                enabled: data.general_notifications_enabled || false,
                allowed_couriers: (data.general_notifications_allowed_couriers || []).map(
                  (o) => o?.value ?? o
                ),
                allowed_triggers: (data.general_notifications_allowed_triggers || []).map(
                  (o) => o?.value ?? o
                ),
              },
              order_confirmation: {
                enabled: data.order_confirmation_enabled || false,
              },
              abandoned_checkouts: {
                enabled: data.abandoned_checkouts || false,
              },
              is_sub_brands_enabled: data.is_sub_brands_enabled || false,
              modules: {
                growth: {
                  enabled: data.growth_module_enabled || false,
                },
                shipping: {
                  enabled: data.shipping_module_enabled ?? true,
                },
              },
            },
          };
          redundantFields.forEach(field => {
            delete body[field];
          });
          const res = await onAddMerchant(
            body,
            {
              "Content-Type": "multipart/form-data",
              Authorization: getToken(),
            },
            toast
          );

          if (res) {
            onCloseModal();
            toast({
              status: "success",
              title: "",
              description: "Created successfully",
            });
            setOpenLoader(false);
          }
        }
        setOpenLoader(false);
      }
    }
  };

  const onCloseModal = () => {
    reset();
    onClose();
    if (!isLead) fetchData(filterQuery);
  };

  const getIndustriesDropDown = async () => {
    const industries = await getIndustries(toast);
    return industries;
  };

  const getCustomizationDropDown = async () => {
    const Customization = await getCustomization(toast);
    return Customization;
  };

  const getAreaMappingConfiguration = async () => {
    const config = await getAreaMappingConfig(toast);
    return config;
  };

  const getMerchantPermissionsList = async () => {
    const list = await getMerchantPermissions(toast);
    console.log(list);
    return list;
  };

  const redundantFields = ['ndr_enabled',
    'ndr_report_email',
    'ndr_report_email_cc',
    'ndr_report_end_time',
    'ndr_report_exclude_days',
    'allowed_couriers',
    'general_notifications_enabled',
    'general_notifications_allowed_couriers',
    'general_notifications_allowed_triggers',
    'order_confirmation_enabled',
    'abandoned_checkouts',
    'is_sub_brands_enabled',
    'growth_module_enabled',
    'shipping_module_enabled',
  ];

  useEffect(() => {
    register("name", {
      required: "name is required",
      validate: (value) =>
        value.length > 1 && value.length < 150 ? true : "Invalid name",
    });

    register("phone", {
      required: "phone is required",
      validate: (value) => (value?.length === 11 ? true : "Invalid phone"),
    });

    register("hotline", {});

    register("email", {
      required: "email is required",
    });

    register("prefix", {
      required: "prefix is required",
    });

    register("industry", {
      required: "industry is required",
    });

    register("brand", {
      required: "brand is required",
    });

    register("password", {
      required: "password is required",
      validate: (value) => (value?.length >= 8 ? true : "Invalid password"),
    });

    register("order_creation_behavior", {
      required: "order creation behavior is required",
    });

    register("hide_pickup_location", {});

    register("allow_sms_notifications", {});

    register("sms_sender_name", {});
    register("sms_allowed_couriers", []);

    register("permissions", []);

    register("allowed_couriers", []);

    register("ramp_customer_code", {});

    register("ndr_enabled", {});
    register("ndr_report_email", {});
    register("ndr_report_email_cc", {});
    register("ndr_report_end_time", {});
    register("ndr_report_exclude_days", {});

    register("general_notifications_enabled", false);
    register("general_notifications_allowed_couriers", []);
    register("general_notifications_allowed_triggers", {
      validate: (value) => {
        if (watch("general_notifications_enabled")) {
          return (value && value.length > 0) || "Please select at least one status trigger";
        }
        return true;
      }
    });

    register("order_confirmation_enabled", false);
    register("abandoned_checkouts", false);
    register("is_sub_brands_enabled", false);
    register("growth_module_enabled", false);
    register("shipping_module_enabled", true);

    if (isLead) {
      register("plan", {});
    }

    if (isOpen) {
      setOpenLoader(true);
      getIndustriesDropDown().then((res) => {
        setMerchantIndustries(res.industries);
      });

      getCustomizationDropDown().then((res) => {
        const modes = [];
        for (const [modeKey, modeValue] of Object.entries(
          res.customization_modes
        )) {
          modes.push({
            label: modeValue,
            value: modeKey,
          });
        }
        setCustomization(modes);
        setValue("order_creation_behavior", "default");
      });

      getAreaMappingConfiguration().then((res) => {
        setAreaMappingConfig(
          {
            acceptedAreaMappingFile: (res || []).find(
              (record) => record.name === "add-area-mapping"
            )["allowed-types"],
            areaMappingSampleFile: (res || []).find(
              (record) => record.name === "add-area-mapping"
            )["file-url"],
          } || {}
        );
        setOpenLoader(false);
      });

      // Fetch active couriers for allowed_couriers selector
      getCouriers({ filters: { active: true }, page: 1, limit: 10000 }, toast)
        .then((res) => {
          const options = (res?.couriers || []).map((c) => ({
            value: c.id || c._id,
            label: c.name,
          }));
          setCouriersOptions(options);
          // setValue(
          //   "allowed_couriers",
          //   // options.filter((o) =>
          //   //   row.config?.ndr?.allowed_couriers.includes(o.value)
          //   // ) || []
          //   options
          // );
          setValue(
            "sms_allowed_couriers",
            options.filter((o) =>
              row?.sms_settings?.[0]?.allowed_couriers.includes(o.value)
            ) || []
          );
        })
        .catch((error) => {
          console.log("error", error);
          setCouriersOptions([]);
        });

      getSubStatus(toast, "processing", "delivery")
        .then(res => setStatusOptions(res.subStatuses?.filter(s => s.value === 'picked up' || s.value === 'out for delivery') || []));

      if (isLead) {
        setValue("name", row.name);
        setValue("brand", row.brand);
        setValue("email", row.email);
        setValue("industry", row.industry);
        setValue("phone", row.phone);
        getMerchantPermissionsList().then(({ permissions }) => {
          setValue(
            "permissions",
            permissions.map((name) => ({ name, status: false }))
          );
        });
      } else if (row) {
        setValue("name", row.name);
        setValue("brand", row.brand);
        setValue("email", row.email);
        setValue("hide_pickup_location", row.hide_pickup_location);
        setValue("hotline", row.hotline);
        setValue("industry", row.industry);
        setValue("order_creation_behavior", row.order_creation_behavior);
        setValue("password", row.password);
        setValue("prefix", row.prefix);
        setValue("phone", row.phone);
        setValue("permissions", row.permissions);
        setValue(
          "allow_sms_notifications",
          row.allow_sms_notifications || false
        );
        setValue("sms_sender_name", row.sms_sender_name);
        setValue("integrator_fees_with_vat", row.integratorFeeWithVAT || 0);
        setValue("ramp_customer_code", row.ramp_customer_code || "");

        setValue("ndr_enabled", row.config?.ndr?.enabled || false);
        setValue("ndr_report_email", row.config?.ndr?.report_email || "");
        setValue("ndr_report_email_cc", row.config?.ndr?.report_email_cc || "");
        setValue("ndr_report_end_time", row.config?.ndr?.report_end_time || "");
        setValue(
          "ndr_report_exclude_days",
          row.config?.ndr?.report_exclude_days || []
        );
        // Initialize allowed_couriers; will map IDs to options once options are loaded
        setValue(
          "allowed_couriers",
          couriersOptions.filter((o) =>
            (row.config?.ndr?.allowed_couriers || []).includes(o.value)
          ) || []
        );
        // Initialize sms_allowed_couriers if exists
        setValue(
          "sms_allowed_couriers",
          couriersOptions.filter((o) =>
            (row?.sms_settings?.[0]?.allowed_couriers || []).includes(o.value)
          ) || []
        );
        setValue("general_notifications_enabled", row.config?.wa_general_notifications?.enabled || false);
        setValue(
          "general_notifications_allowed_couriers",
          couriersOptions.filter((o) =>
            (row.config?.wa_general_notifications?.allowed_couriers || []).includes(o.value)
          ) || []
        );
        setValue("general_notifications_allowed_triggers", statusOptions.filter((o) =>
          (row.config?.wa_general_notifications?.allowed_triggers || []).includes(o.value)
        ) || []);
        setValue("order_confirmation_enabled", row.config?.order_confirmation?.enabled || false);
        setValue("abandoned_checkouts", row.config?.abandoned_checkouts?.enabled || false);
        setValue("is_sub_brands_enabled", row.config?.is_sub_brands_enabled || false);
        setValue("growth_module_enabled", row.config?.modules?.growth?.enabled || false);
        setValue("shipping_module_enabled", row.config?.modules?.shipping?.enabled ?? true);
      } else {
        getMerchantPermissionsList().then(({ permissions }) => {
          setValue(
            "permissions",
            permissions.map((name) => ({ name, status: false }))
          );
        });
        // setValue(
        //   "allowed_couriers",
        //   couriersOptions.filter((o) =>
        //     row.config?.ndr?.allowed_couriers.includes(o.value)
        //   ) || []
        // );
        setValue("sms_allowed_couriers", []);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    getCouriers({ filters: { active: true }, page: 1, limit: 10000 }, toast)
      .then((res) => {
        const options = (res?.couriers || []).map((c) => ({
          value: c.id || c._id,
          label: c.name,
        }));
        setCouriersOptions(options);
        // setValue(
        //   "allowed_couriers",
        //   options.filter((o) =>
        //     row.config?.ndr?.allowed_couriers.includes(o.value)
        //   ) || []
        // );
        // setValue(
        //   "sms_allowed_couriers",
        //   options.filter((o) =>
        //     row?.sms_settings?.[0]?.allowed_couriers.includes(o.value)
        //   ) || []
        // );
      })
      .catch((error) => {
        console.log("error", error);
        setCouriersOptions([]);
      });
    getSubStatus(toast, "processing", "delivery")
        .then(res => {
          const options = (res?.subStatuses?.filter(s => s.value === 'picked up' || s.value === 'out for delivery') || []).map((s) => ({
            value: s.value,
            label: s.label,
          }));
          setStatusOptions(options);
        })
        .catch((error) => {
          console.log("error", error);
          setStatusOptions([]);
        });
  }, [form["allow_sms_notifications"], form["ndr_enabled"], form['general_notifications_enabled']]);

  // Prefill allowed_couriers for edit once options are available
  useEffect(() => {
    if (
      isOpen &&
      row &&
      Array.isArray(row.allowed_couriers) &&
      couriersOptions.length > 0
    ) {
      const selected = row.allowed_couriers
        .map((id) => couriersOptions.find((o) => o.value === id))
        .filter(Boolean);
      console.log(selected);
      setValue("allowed_couriers", selected);
    }
  }, [isOpen, row, couriersOptions]);
  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        {!row && (
          <Button onClick={onOpen}>
            <AddIcon boxSize={4} />
          </Button>
        )}
        {row && (
          <Box onClick={onOpen}>
            <Text>{isLead ? "Convert to merchant" : "Edit Merchant"}</Text>
          </Box>
        )}
      </Box>
      <Modal
        size={"5xl"}
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseModal}
      >
        <ModalOverlay />
        <ModalContent my={8} maxH="calc(100vh - 4rem)">
          <ModalHeader>
            {isLead
              ? "Convert to merchant"
              : !row
              ? "Add Merchant"
              : `Edit ${row.name}`}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody display={"flex"} flexDir={"row"} gap={"6rem"} overflowY="auto">
            <Loader isLoading={openLoader} />
            <Box w={"40%"} display={"flex"} flexDir={"column"} gap={6}>
              <SectionTitle>Merchant Details</SectionTitle>

              <FormControl
                isInvalid={!!errors.name}
                isRequired
                isDisabled={row?.name}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Name
                </FormLabel>
                <Input
                  placeholder="Enter name"
                  type="text"
                  value={form["name"]}
                  onChange={(e) => {
                    setValue("name", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors.phone}
                isRequired
                isDisabled={row?.phone}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Phone
                </FormLabel>
                <Input
                  placeholder="Enter Phone"
                  type="number"
                  value={form["phone"]}
                  onChange={(e) => {
                    setValue("phone", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.phone?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors.email}
                isRequired
                isDisabled={row?.email}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Email
                </FormLabel>
                <Input
                  placeholder="Enter email"
                  type="email"
                  value={form["email"]}
                  onChange={(e) => {
                    setValue("email", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors.password}
                isRequired
                isDisabled={row?.password}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Password
                </FormLabel>
                <Input
                  placeholder="Enter Password"
                  type="password"
                  value={form["password"]}
                  onChange={(e) => {
                    setValue("password", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.password?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors.prefix}
                isRequired
                isDisabled={row?.prefix}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Prefix
                </FormLabel>
                <Input
                  placeholder="Enter prefix"
                  type="text"
                  value={form["prefix"]}
                  onChange={(e) => {
                    setValue("prefix", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.prefix?.message}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={!!errors.brand} isRequired>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Brand
                </FormLabel>
                <Input
                  placeholder="Enter brand"
                  type="text"
                  value={form["brand"]}
                  onChange={(e) => {
                    setValue("brand", e.target.value);
                  }}
                />
                <FormErrorMessage>{errors.brand?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors.industry}
                isRequired
                isDisabled={row?.industry}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Industry
                </FormLabel>

                <Select
                  onChange={(e) => {
                    setValue("industry", e.target.value);
                  }}
                  value={form["industry"]}
                  placeholder="Select Industry"
                >
                  {merchantIndustries?.map((rec, i) => (
                    <option key={i} value={rec}>
                      {rec}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage>{errors.industry?.message}</FormErrorMessage>
              </FormControl>

              <FormControl>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Hotline
                </FormLabel>
                <Input
                  placeholder="Enter Hotline"
                  type="text"
                  value={form["hotline"]}
                  onChange={(e) => {
                    setValue("hotline", e.target.value);
                  }}
                />
              </FormControl>

              {isLead && (
                <FormControl isInvalid={!!errors.plan}>
                  <FormLabel fontSize={12} fontWeight={"semibold"}>
                    Plan
                  </FormLabel>
                  <AsyncSelect
                    defaultOptions
                    placeholder="Select a plan..."
                    getOptionLabel={(v) => v.name}
                    getOptionValue={(v) => v.id}
                    noOptionsMessage={() => "No results"}
                    loadOptions={fetchPricingPlanOptions}
                    onChange={(plan) => {
                      setValue("plan", plan.id);
                    }}
                  />
                  <FormErrorMessage>{errors.plan?.message}</FormErrorMessage>
                </FormControl>
              )}

              <FormControl>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Integrator Fees With VAT
                </FormLabel>
                <Input
                  placeholder="Enter Integrator Fees With VAT"
                  type="number"
                  value={form["integrator_fees_with_vat"]}
                  onChange={(e) => {
                    setValue("integrator_fees_with_vat", e.target.value);
                  }}
                />
              </FormControl>

              <FormControl>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  RAMP Customer Code
                </FormLabel>
                <Input
                  placeholder="Enter RAMP Customer Code"
                  type="text"
                  value={form["ramp_customer_code"]}
                  onChange={(e) => {
                    setValue("ramp_customer_code", e.target.value);
                  }}
                />
              </FormControl>

              <SectionTitle>Order Settings</SectionTitle>

              <FormControl
                isInvalid={!!errors.order_creation_behavior}
                isDisabled={row?.order_creation_behavior}
              >
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Customization
                </FormLabel>

                <Select
                  onChange={(e) => {
                    setAreaMappingFile("");
                    setAreaMappingErrorFile("");
                    setValue("order_creation_behavior", e.target.value);
                  }}
                  value={form["order_creation_behavior"]}
                  placeholder="Select Mode"
                >
                  {customization.map((rec, i) => (
                    <option key={i} value={rec.value}>
                      {rec.label}
                    </option>
                  ))}
                </Select>

                <FormErrorMessage>
                  {errors.order_creation_behavior?.message}
                </FormErrorMessage>
              </FormControl>

              {form["order_creation_behavior"] === "custom" && (
                <FormControl
                  isRequired
                  display={"flex"}
                  alignItems={"center"}
                  flexDirection={"row"}
                >
                  <Box w={"55%"} display={"flex"} alignItems={"center"}>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Area Mapping File
                    </FormLabel>
                    <Box
                      position={"absolute"}
                      mt={"7"}
                      color={"blue"}
                      fontSize={12}
                      cursor={"pointer"}
                      onClick={() => {
                        window.open(
                          baseURL +
                            "/" +
                            areaMappingConfig.areaMappingSampleFile
                        );
                      }}
                    >
                      Download Sample
                    </Box>
                  </Box>

                  <Box display={"flex"} flexDirection={"column"} h={"10rem"}>
                    <div className="app">
                      <div className="parent" style={{ width: "250px" }}>
                        <div className="file-upload">
                          <UploadIcon />
                          {!areaMappingFile && <p>Maximum file size 5mb</p>}
                          {areaMappingFile && <p>{areaMappingFile?.name}</p>}
                          <input
                            type="file"
                            onChange={(e) => {
                              if (
                                areaMappingConfig.acceptedAreaMappingFile.includes(
                                  e.target.files[0]?.type
                                ) &&
                                e.target.files[0]?.size < 5000000
                              ) {
                                setAreaMappingFile(e.target.files[0]);
                              } else
                                toast({
                                  status: "error",
                                  title: "Error.",
                                  description: "Invalid File Type",
                                });
                            }}
                            onClick={(e) => {
                              setAreaMappingErrorFile("");
                              e.target.value = null;
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {areaMappingErrorFile && (
                      <Box display={"flex"} justifyContent={"center"} mt={"-2"}>
                        <Box
                          color={"#e64646"}
                          fontSize={14}
                          cursor={"pointer"}
                          onClick={async () => csvLink.current.link.click()}
                        >
                          Download Error
                        </Box>
                        <CSVLink
                          data={areaMappingErrorFile}
                          filename="area-mapping-errors.csv"
                          className="hidden"
                          ref={csvLink}
                          target="_blank"
                        />
                      </Box>
                    )}
                  </Box>
                </FormControl>
              )}

              <FormControl
                isInvalid={!!errors.hide_pickup_location}
                display="flex"
                alignItems="center"
              >
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Hide Pickup Location
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["hide_pickup_location"]}
                  onChange={(e) =>
                    setValue("hide_pickup_location", e.target.checked)
                  }
                />
              </FormControl>

              {isLead && (
                <FormControl
                  display={"flex"}
                  alignItems={"center"}
                  flexDirection={"row"}
                >
                  <Box w={"55%"}>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Courier Recommendation File
                    </FormLabel>
                    <Box
                      mt={-2}
                      color={"blue"}
                      fontSize={12}
                      cursor={"pointer"}
                      onClick={async () => {
                        downloadRecommendationFileSample(toast);
                      }}
                    >
                      Download Sample
                    </Box>
                  </Box>

                  <Box display={"flex"} flexDirection={"column"} h={"10rem"}>
                    <div className="app">
                      <div className="parent" style={{ width: "250px" }}>
                        <div className="file-upload">
                          <UploadIcon />
                          {!courierRecommendationFile && (
                            <p>Maximum file size 5mb</p>
                          )}
                          {courierRecommendationFile && (
                            <p>{courierRecommendationFile?.name}</p>
                          )}
                          <input
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (!file) {
                                setCourierRecommendationFile("");
                                setCourierRecommendationFileError("");
                              } else if (file.size > 5e6) {
                                toast({
                                  status: "error",
                                  title: "Error.",
                                  description:
                                    "The maximum allowed file size is 5 MB",
                                });
                              } else {
                                setCourierRecommendationFile(file);
                              }
                            }}
                            onClick={(e) => {
                              setCourierRecommendationFileError("");
                              e.target.value = null;
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {courierRecommendationFileError && (
                      <Box display={"flex"} justifyContent={"center"} mt={"-2"}>
                        <Box
                          color={"#e64646"}
                          fontSize={14}
                          cursor={"pointer"}
                          onClick={async () => csvLink.current.link.click()}
                        >
                          Download Error
                        </Box>
                        <CSVLink
                          data={courierRecommendationFileError}
                          filename="courier-recommendation-errors.csv"
                          className="hidden"
                          ref={csvLink}
                          target="_blank"
                        />
                      </Box>
                    )}
                  </Box>
                </FormControl>
              )}
            </Box>

            <Box w={"40%"} display={"flex"} flexDir={"column"} gap={6}>
              <SectionTitle>Modules & Features</SectionTitle>

              <FormControl>
                <Box display="flex" alignItems="center">
                  <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                    Enable Shipping Module
                  </FormLabel>
                  <Switch
                    defaultValue={true}
                    isChecked={form["shipping_module_enabled"]}
                    onChange={(e) =>
                      setValue("shipping_module_enabled", e.target.checked)
                    }
                  />
                </Box>
                <FormHelperText>
                  When enabled (and the merchant has an active plan), the Shipping module is active in the merchant portal. Turn off for growth-only merchants.
                </FormHelperText>
              </FormControl>

              <FormControl>
                <Box display="flex" alignItems="center">
                  <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                    Enable Growth Module
                  </FormLabel>
                  <Switch
                    defaultValue={false}
                    isChecked={form["growth_module_enabled"]}
                    onChange={(e) =>
                      setValue("growth_module_enabled", e.target.checked)
                    }
                  />
                </Box>
                <FormHelperText>
                  When enabled, the merchant is subscribed to the Growth & Engagement module in the merchant portal.
                </FormHelperText>
              </FormControl>

              <FormControl>
                <Box display="flex" alignItems="center">
                  <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                    Enable Sub Brands
                  </FormLabel>
                  <Switch
                    defaultValue={false}
                    isChecked={form["is_sub_brands_enabled"]}
                    onChange={(e) =>
                      setValue("is_sub_brands_enabled", e.target.checked)
                    }
                  />
                </Box>
                <FormHelperText>
                  When enabled, merchants can set a sub-brand per order and use it on AWB labels.
                </FormHelperText>
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Abandoned checkouts
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["abandoned_checkouts"]}
                  onChange={(e) => setValue("abandoned_checkouts", e.target.checked)}
                />
              </FormControl>

              <SectionTitle>Notifications</SectionTitle>

              <FormControl
                isInvalid={!!errors.allow_sms_notifications}
                display="flex"
                alignItems="center"
              >
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Enable SMS Notifications
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["allow_sms_notifications"]}
                  onChange={(e) =>
                    setValue("allow_sms_notifications", e.target.checked)
                  }
                />
              </FormControl>

              {form["allow_sms_notifications"] && (
                <FormControl isInvalid={!!errors.sms_sender_name}>
                  <FormLabel fontSize={12} fontWeight={"semibold"}>
                    SMS Sender Name
                  </FormLabel>
                  <Input
                    placeholder="Enter SMS Sender Name"
                    type="text"
                    value={form["sms_sender_name"]}
                    onChange={(e) => {
                      setValue("sms_sender_name", e.target.value);
                    }}
                  />
                  <FormHelperText>
                    Defaults to "Fincart EG" if left empty
                  </FormHelperText>
                  <Box mt={4}>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      SMS Allowed Couriers (optional)
                    </FormLabel>
                    <ReactSelect
                      isMulti
                      placeholder="Select couriers..."
                      value={form["sms_allowed_couriers"]}
                      onChange={(vals) =>
                        setValue("sms_allowed_couriers", vals || [])
                      }
                      options={couriersOptions}
                    />
                    <FormHelperText>
                      Leave empty to allow all couriers for SMS
                    </FormHelperText>
                  </Box>
                </FormControl>
              )}

              <FormControl display="flex" alignItems="center">
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Enable NDR Reports
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["ndr_enabled"]}
                  onChange={(e) => setValue("ndr_enabled", e.target.checked)}
                />
              </FormControl>

              {form["ndr_enabled"] && (
                <>
                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      NDR Report Email
                    </FormLabel>
                    <Input
                      placeholder="Enter report email"
                      type="email"
                      value={form["ndr_report_email"]}
                      onChange={(e) => {
                        setValue("ndr_report_email", e.target.value);
                      }}
                    />
                    <FormHelperText>
                      Email address to receive NDR reports
                    </FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      NDR Report CC Email
                    </FormLabel>
                    <Input
                      placeholder="Enter CC email"
                      type="email"
                      value={form["ndr_report_email_cc"]}
                      onChange={(e) => {
                        setValue("ndr_report_email_cc", e.target.value);
                      }}
                    />
                    <FormHelperText>
                      CC email address for NDR reports
                    </FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Report Send Time
                    </FormLabel>
                    <Input
                      placeholder="Enter end time (e.g., 18:00)"
                      type="time"
                      value={form["ndr_report_end_time"]}
                      onChange={(e) => {
                        setValue("ndr_report_end_time", e.target.value);
                      }}
                    />
                    <FormHelperText>
                      Time when NDR reports should send
                    </FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Allowed Couriers (optional)
                    </FormLabel>
                    <ReactSelect
                      isMulti
                      placeholder="Select couriers..."
                      value={form["allowed_couriers"]}
                      onChange={(vals) =>
                        setValue("allowed_couriers", vals || [])
                      }
                      options={couriersOptions}
                    />
                    <FormHelperText>
                      Leave empty to allow all couriers
                    </FormHelperText>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Exclude Days
                    </FormLabel>
                    <Stack direction="row" wrap="wrap">
                      {[
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                      ].map((day) => (
                        <Checkbox
                          key={day}
                          isChecked={form["ndr_report_exclude_days"].includes(
                            day.toLowerCase()
                          )}
                          onChange={(e) => {
                            const currentDays =
                              form["ndr_report_exclude_days"] || [];
                            if (e.target.checked) {
                              setValue("ndr_report_exclude_days", [
                                ...currentDays,
                                day.toLowerCase(),
                              ]);
                            } else {
                              setValue(
                                "ndr_report_exclude_days",
                                currentDays.filter(
                                  (d) => d !== day.toLowerCase()
                                )
                              );
                            }
                          }}
                        >
                          {day}
                        </Checkbox>
                      ))}
                    </Stack>
                    <FormHelperText>
                      Days to exclude from NDR reporting
                    </FormHelperText>
                  </FormControl>
                </>
              )}

              <FormControl display="flex" alignItems="center">
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Enable WhatsApp Order Confirmation
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["order_confirmation_enabled"]}
                  onChange={(e) => setValue("order_confirmation_enabled", e.target.checked)}
                />
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel fontSize={12} fontWeight={"semibold"} mb={0}>
                  Enable WhatsApp General Notifications
                </FormLabel>
                <Switch
                  defaultValue={false}
                  isChecked={form["general_notifications_enabled"]}
                  onChange={(e) => setValue("general_notifications_enabled", e.target.checked)}
                />
              </FormControl>

              {form["general_notifications_enabled"] && (
                <>
                  <FormControl 
                    isInvalid={!!errors.general_notifications_allowed_triggers} 
                    isRequired
                  >
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Allowed Status Triggers
                    </FormLabel>
                    <ReactSelect
                      isMulti
                      placeholder="Select Statuses..."
                      value={form["general_notifications_allowed_triggers"] || []}
                      onChange={(vals) =>
                        setValue("general_notifications_allowed_triggers", vals || [], { shouldValidate: true })
                      }
                      options={statusOptions}
                    />
                    <FormErrorMessage>
                      {errors.general_notifications_allowed_triggers?.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl>
                    <FormLabel fontSize={12} fontWeight={"semibold"}>
                      Allowed Couriers (optional)
                    </FormLabel>
                    <ReactSelect
                      isMulti
                      placeholder="Select couriers..."
                      value={form["general_notifications_allowed_couriers"]}
                      onChange={(vals) =>
                        setValue("general_notifications_allowed_couriers", vals || [])
                      }
                      options={couriersOptions}
                    />
                    <FormHelperText>
                      Leave empty to allow all couriers
                    </FormHelperText>
                  </FormControl>
                </>
              )}

              <SectionTitle>Permissions</SectionTitle>

              <FormControl isInvalid={!!errors.permissions}>
                <FormLabel fontSize={12} fontWeight={"semibold"}>
                  Permissions
                </FormLabel>
                <Stack spacing={1} direction="column">
                  {form.permissions.map(({ name, status }, index) => {
                    return (
                      <Checkbox
                        isChecked={status}
                        id={index}
                        onChange={(v) =>
                          setValue(
                            `permissions.${index}.status`,
                            v.target.checked
                          )
                        }
                      >
                        {name}
                      </Checkbox>
                    );
                  })}
                </Stack>
                <FormErrorMessage>
                  {errors.permissions?.message}
                </FormErrorMessage>
              </FormControl>
            </Box>
          </ModalBody>
          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit(handelSubmit, onError)}
              size="sm"
              color={"white"}
              colorScheme="blue"
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>{" "}
    </>
  );
}
